import React from "react";
import Header from "../../components/Customer/Header";
import Footer from "../../components/Customer/Footer";

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-amber-100 font-sans">
      <Header />
      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 font-poppins mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-10">Last updated: April 2026</p>

        <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Who We Are</h2>
            <p>
              Araliya Tours is a Melbourne-based travel and transport service operating across Victoria and Australia.
              We provide airport transfers, day trips, and guided tours. This policy explains how we handle the personal
              information you provide when making a booking enquiry through our website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">What Information We Collect</h2>
            <p>When you submit a booking enquiry, we collect:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Your full name</li>
              <li>Your email address</li>
              <li>Your phone number</li>
              <li>Trip details such as destination, date, number of guests, and vehicle preference</li>
            </ul>
            <p className="mt-3">
              We do not collect payment information, credit card details, or any sensitive personal information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">How We Use Your Information</h2>
            <p>We use your information solely to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Respond to your booking enquiry</li>
              <li>Confirm trip details and provide a quote</li>
              <li>Contact you regarding your booking</li>
            </ul>
            <p className="mt-3">
              We do not use your information for marketing purposes, and we do not sell or share your
              information with third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">How Your Information Is Transmitted</h2>
            <p>
              Booking enquiries submitted through our website are processed using{" "}
              <a href="https://www.emailjs.com" className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">EmailJS</a>,
              a third-party email delivery service. Your enquiry details are sent directly to our inbox and are not stored
              on any external server beyond what EmailJS requires to deliver the message.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Cookies</h2>
            <p>
              Our website does not use tracking cookies, advertising cookies, or analytics tools. No personal
              data is stored in your browser.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Your Rights</h2>
            <p>
              Under the Australian Privacy Act 1988, you have the right to request access to the personal
              information we hold about you, and to ask us to correct or delete it. To make a request,
              please contact us at the email below.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact</h2>
            <p>
              If you have any questions about this policy or how we handle your information, please contact us at:{" "}
              <a href="mailto:araliyatoursmelb@gmail.com" className="text-blue-600 hover:underline">
                araliyatoursmelb@gmail.com
              </a>
            </p>
          </section>

        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
